
import React, {  useState } from 'react';
import { View, Text, TouchableOpacity , Image, ActivityIndicator} from 'react-native';
import { CreateResponsiveStyle, DEVICE_SIZES, maxSize} from "rn-responsive-styles";
import CImage from './CImage';
import {logout} from "./../api/apiManager";
import AsyncStorageFunc from '../utilities/asyncStorage';
import RootNavigation from "../utilities/RootNavigation";
import { useLogin } from '../context/loginProvider';


// create a component
const MobileHeader = (props) => {
    const styles = useStyles();
    const IMG_DATA = global.userProfileImg  ||""
    const [isShowSidebar, setIsShowSidebar] = useState(true);
    const [loading, setLoading] = useState(false);
    const { isLoggedIn, setIsLoggedIn } = useLogin();

    const userLogout = params =>{
        setLoading(true)
        let req = {
                userId : global.userId
        }
        logout(req).then((res)=>{
              
        setTimeout(() => {
                setLoading(false)
                AsyncStorageFunc.deleteData('TOKEN').then((tokenRes) => {
                        console.log(tokenRes,'tokenRes3')
                        setIsLoggedIn(false)
                        RootNavigation.navigate("Login")
                });
                }, 1000);

        }).catch()
}
const onclickHamburger = () => {
    setIsShowSidebar(!isShowSidebar)
    global.sidebarHide = true
    props.isShowSidebar(isShowSidebar)
}
    return (
        <View style={styles.container}>
            <View style={styles.mobileHeaderView}>
                <View style={styles.mobileContentView}>
                    <View style={styles.hamburgerViewStyle}>
                        <TouchableOpacity
                            style={{}}
                            onPress={() => {
                                onclickHamburger()
                            }}
                        >
                            {!isShowSidebar ? (
                                <CImage.HamburgerMenuWhite></CImage.HamburgerMenuWhite>
                            ) : (
                                <CImage.CloseIcon1></CImage.CloseIcon1>
                            )}
                        </TouchableOpacity>
                    </View>
                    <View style={{ flexDirection: "row" }}>
                        <View
                            style={styles.defaultProfilePicBg}   >
                            {IMG_DATA == "" || IMG_DATA == null ? (
                                <CImage.DefaultProfilePic></CImage.DefaultProfilePic>
                                ) : (
                                <Image
                                    source={{ uri: `data:image/png;base64,${IMG_DATA}` }}
                                    style={{
                                        height: "100%",
                                        width: "100%",
                                        borderRadius: 100,
                                        marginRight: 10,
                                    }}
                                />
                            )}
                        </View>
                        <View style={{ alignItems: "flex-start", justifyContent: "center" }}>
                            <Text style={styles.mobileUserNameStyle}>
                                {global?.fullName || ""}
                            </Text>
                            <TouchableOpacity onPress={() => userLogout()}>
                                <Text style={styles.switchTextStyle} >
                                    {"Switch to "}
                                    <Text style={[styles.switchTextStyle,{ textDecorationLine: "underline", }]}>
                                        {"other user"}
                                    </Text>
                                </Text>
                            </TouchableOpacity>
                        </View>
                        {loading && <ActivityIndicator size={"large"} color="#707070" style={styles.spinner} />}
                    </View>
                </View>
            </View>
        </View>
    );
};

// define your styles
const useStyles = CreateResponsiveStyle({
    container: {
        width: "100%",
    },
    mobileContentView:{
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        flex: 1,
        marginHorizontal: 30,
    },
    defaultProfilePicBg:{
        width: 45,
        height: 45,
        borderRadius: 50,
        marginRight: 10,
        margin: 10,
    },
    mobileHeaderView: {
        flexDirection: "row",
        justifyContent: "space-between",
        display: "none",
        backgroundImage:
          "linear-gradient(#1A1A1A 100%,#343434 50%, #1A1A1A 80%,#343434 50%)",
      },
      hamburgerViewStyle:{
        display:"none"
      },
      mobileUserNameStyle:{
        fontFamily: "Inter",
        fontSize: 24,
        color: "#ffffff",
      },
      switchTextStyle:{
        fontFamily: "Inter",
        fontSize:  15,
        lineHeight:  22,
        color: "#ffffff",
      },
      spinner:{
        position:'absolute',
        right:84,
        top:30,
        zIndex:999,
        width:100,
        height:30,
        backgroundColor:'transparent'
},
overlayViewStyle: {
    position: "absolute",
    zIndex: 9999,
    backgroundColor: "rgba(52,52,52,0.9)",
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    borderRadius: 15,
  },

}, 
{
    [DEVICE_SIZES.SM]: {
        hamburgerViewStyle:{
          display:"flex"
        },
      },
    [maxSize(DEVICE_SIZES.XS)]: {
        mobileHeaderView: {
            display: "flex",
          },
          mobileContentView:{
            marginHorizontal:17
          },
          hamburgerViewStyle:{
            display:"flex"
          },
          mobileUserNameStyle:{
            fontSize: 16,
            lineHeight: 22,
          },
          switchTextStyle:{
            fontSize: 10,
            lineHeight: 11,
          },
          
    },
});

export default MobileHeader;
